import { Component, OnInit } from "@angular/core";
import { UsrCred } from "./../../models/usrcred";
import { VproService } from "./../../service/vpro/vpro.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-forgot-pass",
  templateUrl: "./forgot-pass.component.html",
  styleUrls: ["./forgot-pass.component.css"]
})
export class ForgotPassComponent {
  submitted = false;
  user = new UsrCred();
  dataValue: boolean;
  innerHtml: string;
  constructor(private mailCheckService: VproService) { }

  lookUp() {
    //  localStorage.setItem('getUsr', this.user.email_id); // Capturing Loggedin User

    this.submitted = true;
    // Shoot a mail to user

    this.mailCheckService.mailUsrpwd(this.user).subscribe();

    Swal.fire({
      allowOutsideClick: false,
      position: "top",
      type: "success",
      title:
        "An email has been sent to your registered Email-id, Please check your mail for Password Reset Link ",
      showConfirmButton: false,
      timer: 2100
    });
  }
}

/*
 this.mailCheckService.claimAuth(this.user).subscribe(data => {
        this.dataValue = data['auth'];
          // this.dataValue2 = data['utype'];
        if (data) {
          
          
           this.router.navigate(['/setNewPass']);
        }
        if (data === null) {
          
          this.innerHtml = '<b>No such email-id registered with us</b>';

        } else {
         this.innerHtml = "Some exception occured, please contact Admin !";
        }
      }, error => {
      });
 */
